import angular from 'angular';

import { LeadFormCtrl } from './lead.form.controller';

export const leadForm: angular.IDirectiveFactory = (
  $timeout: angular.ITimeoutService,
) => ({
  require: 'ngModel',
  bindToController: true,
  controller: LeadFormCtrl,
  controllerAs: 'vm',
  templateUrl(elem, attrs) {
    return (
      attrs.templateUrl ||
      new URL('app/lead.form/lead.form.html?raw', import.meta.url)
    );
  },
  link() {
    $timeout(() =>
      angular.element(document.getElementsByName('lead-form-name')).focus(),
    );
  },
  restrict: 'AE',
  scope: {
    lead: '=ngModel',
    autocomplete: '=autocomplete',
    hasTimer: '=?hasTimer',
    hideCustomFields: '=hideCustomFields',
    phone: '=?phone',
    email: '=?email',
    saveFn: '&save',
    cancelFn: '&cancel',
  },
});

leadForm.$inject = ['$timeout'];
